module.exports = __webpack_public_path__ + "static/media/presentation_2.c7c251d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/presentation_2.svg
// module id = 654
// module chunks = 1